import { VaroCategories } from 'shared/analytics/types/categories';

export const VaroPressableNames = {
  DCF: {
    DCF_ADD_MONEY_NEW_CARD: 'dcf_add_money_new_card',
    DCF_ADD_MONEY_SAVED_CARD: 'dcf_add_money_saved_card',
  },
} as const satisfies Partial<
  Record<keyof typeof VaroCategories, Record<string, string>>
>;

export type VaroPressableName = {
  [K in keyof typeof VaroPressableNames]: (typeof VaroPressableNames)[K][keyof (typeof VaroPressableNames)[K]];
}[keyof typeof VaroPressableNames];
